"use client";

import PropTypes from "prop-types";
import { usePlausible } from "next-plausible";
import { Header } from "@appsignal-tools/design-system";
import NextLink from "components/NextLink";

import features from "config/api/generated/features";
import languages from "config/api/generated/languages";

import useAuthenticated from "hooks/useAuthenticated";
import useSetBodyScroll from "hooks/useSetBodyScroll";

export default function AppHeader({ domain }) {
  const plausible = usePlausible();
  const [authenticated] = useAuthenticated();
  const { setBodyScroll } = useSetBodyScroll();

  return (
    <Header
      domain={domain}
      authenticated={authenticated}
      headerLink={NextLink}
      features={features}
      languages={languages}
      onBodyScrollUpdate={(value) => setBodyScroll(value)}
      onUserSignUp={() => plausible("signup_from_docs")}
    />
  );
}

AppHeader.propTypes = {
  domain: PropTypes.string.isRequired,
};
